import axios from "axios";
import api from "../axios";

export async function uploadToS3(files) {
  const bucket = "orga-distrib-images";
  // pega image_details: {filename, filetype}
  // changes file names to add a random string to avoid conflicts
  files = files.map((fileWrapper) => {
    let file = fileWrapper.file;
    const randomString = Math.random().toString(36).substring(2, 15);
    const ext = file.name.split(".").pop();
    const baseName = file.name.replace(/\.[^/.]+$/, ""); // remove a extensão
    const newFileName = `${randomString}-${baseName}.${ext}`;
    return new File([file], newFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  });

  const image_details = files.map((file) => {
    return {
      filename: file.name,
      filetype: file.type,
    };
  });
  let response = await api.post("/utils/get-signed-link", {
    bucket,
    image_details,
  });
  const uploadLinks = response.data.data;
  // upload using put and axios
  const uploadPromises = uploadLinks.map(async (info, index) => {
    await axios.put(info, files[index], {
      headers: {
        "Content-Type": files[index].type,
      },
    });
    return `https://img.hdup.com.br/fit-in/500x500/${bucket}/${files[index].name}`;
  });
  let finalurls = await Promise.all(uploadPromises);
  return finalurls;
}

export async function getDashboardData() {
  try {
    const response = await api.get("/utils/dashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
}
